import addClasses from './addClasses.js';
import removeClasses from './removeClasses.js';
export default {
  addClasses,
  removeClasses
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/core/classes/index.js
// module id = 1143
// module chunks = 9